import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  analyticsAllowedHere,
  enableAnalytics,
  pauseAnalytics,
  readConsent,
  saveConsent,
  trackPageView,
} from '../../lib/analytics';

/**
 * Runs analytics for one marketing page: asks once, loads Google Analytics
 * only after "Accept", counts the page view, and pauses again on the way out
 * (so app pages and link pages are never sent).
 */
export function useMarketingAnalytics() {
  const location = useLocation();
  const allowed = analyticsAllowedHere();
  const [consent, setConsent] = useState(() => readConsent());
  const active = allowed && consent === 'granted';

  useEffect(() => {
    if (!active) return undefined;
    enableAnalytics();
    return () => pauseAnalytics();
  }, [active]);

  useEffect(() => {
    if (active) trackPageView(location.pathname);
  }, [active, location.pathname]);

  const choose = (value) => {
    saveConsent(value);
    setConsent(value);
  };
  return {
    showBanner: allowed && consent === null,
    canChange: allowed,
    accept: () => choose('granted'),
    decline: () => choose('denied'),
    reopen: () => choose(null),
  };
}
